import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

/* Components */
import Dashboard from "../containers/dashboard/Dashboard.js";
import Login from "../containers/Login";
import His from "../containers/His";
import ResetPassword from "../containers/ResetPassword";
import ResetPasswordRCF from "../containers/ResetPasswordRCF";
import ResetPasswordStaff from "../containers/ResetPasswordStaff";
import ChatWindow from "../containers/ChatWindow";
import ChatUserWindow from "../components/staff/ChatUserWindow";
import Register from "../containers/Register";
import NotFound from "../containers/NotFound";
//import FaceCapture from '../containers/FaceCapture';
import FaceRegister from "../containers/FaceRegister";
//import Layout from '../components/Layout';
import SliderAllClinics from "../containers/SliderAllClinics";
import CitappModal from "../containers/dashboard/CitappModal";
import AllClinics from "../containers/AllClinics";
import SelectClinic from "../containers/SelectClinic";
import ConfirmAppointment from "../containers/ConfirmAppointment";
import StaffConfirmAppointment from "../containers/StaffConfirmAppointment";
import DashboardStaff from "../containers/dashboard-staff/DashboardStaff.js";
import PriorityAppointmentModal from "../containers/dashboard/PriorityAppointmentModal";

const App = () => (
  <BrowserRouter basename={"/ct"}>
    <Switch>
      <Route exact path="/" component={SelectClinic}></Route>
      <Route exact path="/dashboard" component={Dashboard}></Route>
      <Route exact path="/staff" component={DashboardStaff}></Route>
      <Route exact path="/login" component={Login}></Route>
      <Route exact path="/register" component={Register}></Route>
      <Route exact path="/facecapture" component={FaceRegister}></Route>
      <Route exact path="/sliderclinics" component={SliderAllClinics}></Route>
      <Route exact path="/clinics" component={AllClinics}></Route>
      <Route exact path="/selectclinic" component={SelectClinic}></Route>
      <Route exact path="/modal" component={CitappModal}></Route>
      <Route exact path="/his" component={His}></Route>
      <Route
        path="/patient_updateinformation:dataFromCitapp"
        component={ConfirmAppointment}
      ></Route>
      <Route
        path="/staff_updateinformation:dataFromCitapp"
        component={StaffConfirmAppointment}
      ></Route>
      <Route
        path="/patient_createpriorityappointment:dataFromCitapp"
        component={PriorityAppointmentModal}
      ></Route>

      <Route path="/resetpassword/" component={ResetPassword}></Route>
      <Route path="/resetpasswordStaff/" component={ResetPasswordStaff}></Route>
      <Route path="/resetpasswordRCF/" component={ResetPasswordRCF}></Route>
      <Route path="/clientchat/" component={ChatWindow}></Route>
      <Route path="/clientuserchat/" component={ChatUserWindow}></Route>
      {/* <Route exact path="/landing" component={CitappModal}></Route> */}
      <Route component={NotFound}></Route>
    </Switch>
  </BrowserRouter>
);

export default App;
